// frontend/src/components/common/MemoPopup.js
import { useState, useEffect, useRef } from 'react';
import Draggable from 'react-draggable';
import axios from 'axios';

export default function MemoPopup() {
  const WEEKDAYS = ['일', '월', '화', '수', '목', '금', '토'];

  const [collapsed, setCollapsed] = useState(true);
  const [todayMemos, setTodayMemos] = useState([]);
  const nodeRef = useRef(null);

  const fetchToday = () =>
    axios
      .get(`${process.env.REACT_APP_API_URL}/memos/today`)
      .then((res) => setTodayMemos(res.data))
      .catch(console.error);

  useEffect(() => {
    fetchToday();
    const interval = setInterval(fetchToday, 60_000);
    return () => clearInterval(interval);
  }, []);

  /* 접힌 상태에서 보여줄 한 줄 요약 */
  const summary =
    todayMemos.length === 0
      ? '오늘의 알림 메모 없음'
      : `${new Date(todayMemos[0].updated_at).toLocaleTimeString()}` +
        (todayMemos[0].content || '').split('\n')[0].slice(0, 30);

  return (
    <>
      {/* 접힌 위젯 */}
      {collapsed && (
        <div
          onClick={() => {
            fetchToday();
            setCollapsed(false);
          }}
          style={{
            bottom: 20,
            right: 20,
            padding: '0.6rem 1rem',
            background: '#ffc',
            border: '1px solid #999',
            borderRadius: 6,
            cursor: 'pointer',
            zIndex: 9000,
            maxWidth: 500,
            width: 500,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'flex',
            alignItems: 'center',
          }}
          title="클릭하여 오늘 알림 메모 보기"
        >
          🔔{' \v  '}
          {todayMemos.length === 0 ? (
            '오늘의 알림 메모 없음'
          ) : (
            <span
              span
              style={{
                fontWeight: 700, // 앞부분 굵게
                fontSize: '0.75rem', // 앞부분 작게
                marginRight: '0.75rem',
              }}
            >
              {new Date(todayMemos[0].updated_at).toLocaleTimeString()}
            </span>
          )}
          {todayMemos.length > 0 && (
            <span>
              {(todayMemos[0].content || '').split('\n')[0].slice(0, 30)}
            </span>
          )}
        </div>
      )}

      {/* 펼친(드래그 가능한) 모달 */}
      {!collapsed && (
        <Draggable handle=".memo-header" nodeRef={nodeRef} bounds="body">
          <div
            ref={nodeRef}
            style={{
              position: 'fixed',
              top: 40,
              left: 400,
              width: 500,
              background: 'white',
              border: '1px solid #666',
              borderRadius: 8,
              zIndex: 9000,
              boxShadow: '0 4px 8px rgba(0,0,0,.15)',
            }}
          >
            {/* 헤더 */}
            <div
              className="memo-header"
              style={{
                padding: '0.5rem 1rem',
                background: '#333',
                color: '#fff',
                cursor: 'move',
                userSelect: 'none',
              }}
            >
              {todayMemos.length > 0
                ? `${todayMemos[0].target_date} (${WEEKDAYS[new Date(todayMemos[0].target_date).getDay()]}) 알림 메모`
                : '오늘의 알림 메모가 없습니다'}
              <button
                onClick={() => setCollapsed(true)}
                style={{
                  float: 'right',
                  background: 'transparent',
                  border: 'none',
                  color: '#fff',
                  cursor: 'pointer',
                }}
              >
                ✕
              </button>
            </div>

            {/* 본문 – 읽기 전용 */}
            <div style={{ padding: '1rem', maxHeight: 450, overflowY: 'auto' }}>
              {todayMemos.length === 0 ? (
                <p style={{ color: '#666' }}>등록된 메모가 없습니다.</p>
              ) : (
                todayMemos.map((memo) => (
                  <div
                    key={memo.id}
                    style={{
                      padding: '0.4rem 0',
                      borderBottom: '1px solid #eee',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '0.75rem',
                        color: '#666',
                        fontWeight: 'bold',
                        marginBottom: '0.5rem',
                      }}
                    >
                      {new Date(memo.updated_at).toLocaleTimeString()}
                    </div>
                    <pre
                      style={{
                        margin: 0,
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-all',
                        fontFamily: 'inherit',
                        fontSize: '1.25rem',
                      }}
                    >
                      {memo.content}
                    </pre>
                  </div>
                ))
              )}
            </div>
          </div>
        </Draggable>
      )}
    </>
  );
}
